module.exports = "/_next/static/images/033d3271c9f56c5d0b2691abab573e20-pix-transfer@1x.png";